import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { reduxForm } from 'redux-form';
import Button from '../../components/elements/Button/Button';
import ButtonFileInput from '../../components/elements/ButtonFileInput/ButtonFileInput';
import ButtonLink from '../../components/elements/ButtonLink';
import LoadingBars from '../../components/elements/LoadingBars';
import styles from './styles.scoped.css';

export function Component({
  change = () => {},
  handleSubmit = () => {},
  infoUpload = [],
  isLoading = false,
  onBack = '/',
  title = '',
}) {
  const [error, setError] = useState({});
  const [file, setFile] = useState({});

  const clearErrors = () => {
    setError({});
  };

  const handleRemoveFormData = () => {
    setFile({});
  };

  const handleChangeFile = (name, val) => {
    const modPayload = { file: val };
    let bodyFormData = new FormData();
    Object.keys(modPayload).forEach((val) => {
      bodyFormData.append(name, modPayload[val]);
    });
    setFile(bodyFormData);
  };

  useEffect(() => {
    change('file', file);
  }, [file]);

  const handleIsValid = () => {
    if (
      file instanceof FormData &&
      Object.keys(error).length === 0 &&
      isLoading !== true
    ) {
      return false;
    }
    return true;
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className={styles['top-content-upload-reg-container']}>
          <div
            className={styles['left-content-upload-reg']}
            style={{ maxWidth: '60%' }}
          >
            <h4>{title}</h4>
            <br />
            <br />
          </div>
          <div className={styles['right-content-upload-reg']}>
            <img
              className={styles['illustration-upload']}
              src="assets/illu-registrasi-pangkalan.svg"
            />
          </div>
        </div>
        <div className={styles['row-between']}>
          <ButtonFileInput
            clearErrors={clearErrors}
            deleteFile={handleRemoveFormData}
            errors={error.file}
            extensionAllowed={['csv']}
            handleChangeFile={handleChangeFile}
            name="file"
            noBase64={true}
            outlined={true}
            setError={setError}
            sizeValidation={{ kbsize: 20000 }}
          >
            Pilih File
          </ButtonFileInput>
          {isLoading && (
            <div style={{ marginLeft: '10px' }}>
              <LoadingBars size={1} />
            </div>
          )}
        </div>
        <hr className={styles.separatorSubMerchantActivation} />
        <div>
          <h5>Cara Tambah Sekaligus:</h5>
          <ol className={styles['step-upload-xlsx-regist-bulk']}>
            {infoUpload &&
              infoUpload.length > 0 &&
              infoUpload.map((item, index) => (
                <li key={index} style={{ marginTop: '1rem' }}>
                  {item}
                </li>
              ))}
          </ol>
        </div>
        <br />
        <div className={styles['action-btn-container']}>
          <ButtonLink
            className={styles['action-btn-back']}
            outlined={true}
            to={onBack}
          >
            Kembali
          </ButtonLink>
          <Button
            className={styles['action-btn-continue']}
            disabled={handleIsValid()}
            type="submit"
          >
            Unggah
          </Button>
        </div>
      </form>
    </>
  );
}

Component.propTypes = {
  change: PropTypes.func,
  handleSubmit: PropTypes.func,
  infoUpload: PropTypes.arrayOf(PropTypes.string),
  isLoading: PropTypes.bool,
  onBack: PropTypes.string,
  title: PropTypes.string,
};

export default reduxForm({
  form: 'bulk-update-sub-merchant-policies',
  initialValues: {
    file: [],
  },
})(Component);
